import { createSlice } from '@reduxjs/toolkit'

interface SubscriptionState {
    data: any[]
    loading: boolean
}

const initialState: SubscriptionState = {
    data: [],
    loading: false
}

const subscriptionSlice = createSlice({
    name: 'subscription',
    initialState: initialState,
    reducers: {
        setSubscriptionData: (state, action) => {
            state.data = action.payload
        },
        addSubscriptionData: (state, action) => {
            state.data = [action.payload, ...state.data]
        },
        updateSubscriptionData: (state, action) => {
            state.data = state.data.map((item) => {
                return item._id === action.payload._id ? action.payload : item
            })
        },
        setLoading: (state, action) => {
            state.loading = action.payload
        }
    }
})

export const { setSubscriptionData, addSubscriptionData, updateSubscriptionData, setLoading } = subscriptionSlice.actions
export default subscriptionSlice.reducer
